import { useTranslation } from 'react-i18next'
import { useRef, useEffect } from 'react'

import { useHospitalDetailContext } from '../hospital-detail-context'

import Section from '@/components/atomic/molecules/Section'
import TagList from '@/components/atomic/organisms/TagList'
import { HospitalBadgeSection } from '@/features/hospital/components/hospital-badge-section'
import { HospitalIntroduction } from '@/features/hospital/components/hospital-introduction'

export const HospitalDetailIntroduction = () => {
  const { t } = useTranslation()
  const { hospital, registerSectionRef } = useHospitalDetailContext()
  const sectionRef = useRef<HTMLDivElement>(null)

  // Register section ref for scroll navigation
  useEffect(() => {
    registerSectionRef('hospitalInfo', sectionRef.current)
    return () => registerSectionRef('hospitalInfo', null)
  }, [registerSectionRef])

  return (
    <div ref={sectionRef}>
      {/* 병원 뱃지 섹션 */}
      <HospitalBadgeSection
        badgeCodes={hospital.badges?.map((badge) => badge.badgeCode) || []}
        badges={hospital.badges || []}
      />

      {/* 병원 소개 */}
      <HospitalIntroduction introduction={hospital.introduction} />

      {/* 진료 태그 목록 */}
      <Section title={t('templates.hospitalDetail.opTagTitle')}>
        <TagList tags={hospital.treatmentTags?.map((tag) => tag.name) || []} />
      </Section>
    </div>
  )
}
